import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import AddressSelector from "@bloonde/location/addresses/components/AddressSelector";
import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function RoomForm(props: Prop) {
  const {formRef, onSubmit, context} = props.formConfig;    
  const { element, setElement, backendFormErrors } = useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});

  const translations = {
    name: t("name"),
    address_id: t("address"),
    capacity: t("capacity"),
    status: t("status"),
    numbered_tickets: t("numbered_tickets"),
  };

  let schema: RJSFSchema = {
    type: "object",
    // required: ['minutes', 'customer_id', 'task', 'date', 'report_id'],
    properties: {
      name: {
        type: "string",
        title: translations.name,
      },
      address_id: {
        type: "integer",
        title: translations.address_id,
      },
      capacity: {
        type: "number",
        minimum: 0,
        title: translations.capacity,
      },
      status: {
        type: "integer",
        title: translations.status,
        default: 1,
        oneOf: [
          {
            const: 1,
            title: "Habilitada",
          },
          {
            const: 2,
            title: "Deshabilitada",
          },
        ],
      },
      numbered_tickets: {
        type: "boolean",
        title: translations.numbered_tickets,
      },
    },
  };
  const uiSchema: UiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    address_id: {
      "ui:widget": "address-selector",
    },
    numbered_tickets: {
      "ui:widget": "switch",
    },
  };
  const customWidgets = {
    ...widgets,
    ...{ 
        "address-selector": AddressSelector,
        "switch": BeelditSwitchInput
      },
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
    />
  );
}

export default RoomForm;
